<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('theme', ['theme']),
  },
  watch: {
    theme(newValue) {
      document.documentElement.setAttribute('theme', newValue);
    },
  },
};
</script>
